import { ComponentType, CSSProperties } from "react";

import { FeatureFlagValue } from "./application";

export interface PartnerLogoProps {
  className?: string;
  style?: CSSProperties;
  width?: number;
  height?: number;
}

export enum PartnerBankKey {
  Mnt = "mnt",
  Flb = "flb",
  Armstrong = "armstrong",
  Umb = "umb",
  GreatPlains = "greatPlains",
  FirstOklahoma = "firstOklahoma",
  Weokie = "weokie",
}

// Drives the deposit-insurance wording in the disclaimers. Banks are FDIC
// insured; credit unions are NCUA insured and take deposits as shares, so the
// two cannot share one sentence.
export enum PartnerInstitutionKind {
  Bank = "bank",
  CreditUnion = "creditUnion",
}

export interface PartnerBankColors {
  gradientStart: string;
  gradientStartOffset: number;
  gradientEnd: string;
  gradientEndOffset: number;
  titleHighlight: string;
  infoCard: string;
  infoCardBorder: string | null;
  featureSubtitle: string;
  motivational: string;
  cta: string;
  ctaText: string;
  banner: string;
}

export interface PartnerBankLogos {
  // Shown on the partnership page badge and the home banner, both of which sit
  // on the partner's own brand colour, so this is the light-on-dark lockup.
  Light: ComponentType<PartnerLogoProps>;
  // Shown in the home footer lockup.
  Color: ComponentType<PartnerLogoProps>;
  // Optional brand artwork behind the partnership page.
  Watermark?: ComponentType<PartnerLogoProps>;
  // Optional brand artwork behind the home banner.
  BannerWatermark?: ComponentType<PartnerLogoProps>;
  // Rendered height on the badge and on the home banner. Width follows each
  // lockup's own aspect ratio, which ranges from wide (UMB) to nearly square
  // (Armstrong).
  badgeHeight: number;
  bannerHeight: number;
}

export interface PartnerBank {
  key: PartnerBankKey;
  partnerId: string;
  featureFlag: FeatureFlagValue;
  displayName: string;
  shortName: string;
  accountName: string;
  institutionKind: PartnerInstitutionKind;
  colors: PartnerBankColors;
  logos: PartnerBankLogos;
  watermarkStyle?: CSSProperties;
}
